import { PackageTypeForm } from "@/resources/packages/PackageTypeForm";

export function BetCreate() {
  return (
    <PackageTypeForm action="create" resource="bets" packageType="bet" label="Bet" />
  );
}

export default BetCreate;
